export class OrderAddressDTO {
	line1: string;
	line2: string | null;
	city: string;
	zipCode: string;
	countryExternalId: string | null;
}